import React, { PropTypes } from 'react';
import DataService from '../../lib/DataService';
import { hashHistory } from 'react-router';
import SharedTools from '../../lib/SharedTools';
import { Button,Select } from "antd";

const Option = Select.Option;

export default class DevelopmentReportIndexPage extends React.Component {
  static propTypes = {
    // name: PropTypes.string.isRequired
  };

  constructor(props) {
    super(props);
    let currentSemester = SharedTools.getCurrentSemester();
    let semesters = SharedTools.getAllSemesters(currentSemester, 20201);
    // set state
    this.state = {
      semester: props.location.query.semester ? props.location.query.semester : SharedTools.getCurrentSemester(),
      semesters,
      classId: props.params.classId ? props.params.classId : 0,
      gradeId: props.location.query.gradeId ? props.location.query.gradeId : '',
      className: props.location.query.className ? props.location.query.className : '',
      students: []
    };
    // bind this
  }

  componentDidMount() {
    DataService.getStudents(this.state.classId).then((res) => {
      this.setState({
        students: res
      })
    }).catch((error) => {
      console.log(error);
    });
  }
  selectSemester(value) {
    if (value != this.state.semester) {
      this.setState({
        semester: value,
      }, () => {
        this.setState({
          records: [],
          loading: false,
          to_id: undefined,
          isBottom: false
        })
        this.componentDidMount()
      })
    }
  }

  _selectSemesterBox() {
    return (
      <div className="select-semester-box">
        <Select value={String(this.state.semester)} style={{ width: 145 }} onChange={this.selectSemester.bind(this)}>
          {this.state.semesters.map((semester, index) => <Option value={String(semester.semester)} key={index}>{semester.semesterToString}</Option>)}
        </Select>
      </div>
    )
  }

  goStudentObservationsListPage(student) {
    let path = `development/report/classes/${this.state.classId}/get_report?gradeId=${this.state.gradeId}`;
    let key = student ? `&studentId=${student.id}&name=${student.full_name}&semester=${this.state.semester}` : `&classId=${this.state.classId}&name=${this.state.className}&semester=${this.state.semester}`;
    hashHistory.push(path + key)
  }

  render() {
    let {className} = this.state;
    return (
      <div className="evaluate-index-page development-report-index-page">
        {this._selectSemesterBox()}
        <div className="class-report-container">
          <Button type="primary" size="large" onClick={() => this.goStudentObservationsListPage(undefined)}>{className}班级报告</Button>
          <div className="report-label">{className}班级整体发展情况报告</div>
        </div>
        <div className="student-report-title">个人报告</div>
        <div className="evaluate-container">
          {this.state.students.map(student => <div className="student-list" key={student.id} onClick={() => this.goStudentObservationsListPage(student)}>
            <div className="student-name">
              {student.full_name}
            </div>
          </div>)}
        </div>
        
      </div>
    )
  }
} 


// WEBPACK FOOTER //
// ./app/javascript/bundles/WebPcApp/components/development/DevelopmentReportIndexPage.jsx